<template>
  <div class="select-address-category-modal">
    <modal-frame :showModalFlag="modalDisplay" :position="'low'" v-on:backdropClickEvent="closeModal">
      <div class="modal-body">
        <div
          class="selectable-categories"
          v-for="category in addressBook"
          :key="'selcate' + category.id"
          @click="categorySelected(category)">
          <div class="current-category-marker">
            <img src="/images/check_icon.png" v-show="!disableCheckMarker && currentCategory && currentCategory.id === category.id"/>
          </div>
          <div class="category-name" :class="{ disable: isCategoryDisable(category) }">
            {{ category.name }}
          </div>
        </div>
      </div>
    </modal-frame>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import ModalFrame from '@/components/common/ModalFrame.vue'

export default {
  name: 'SelectAddressCategoryModal',

  components: {
    ModalFrame
  },

  props: {
    modalDisplay: Boolean,
    currentCategory: Object,
    disableCategories: Array,
    disableCheckMarker: Boolean,
  },

  emits: [
    'categorySelectedEvent',
    'closeModalEvent'
  ],

  computed: {
    ...mapState({
      addressBook: state => state.addressBook.addressCategories,
    }),
  },

  methods: {
    categorySelected (category) {
      if (!this.isCategoryDisable(category) && (!this.currentCategory || this.currentCategory.id !== category.id)) {
        this.$emit('categorySelectedEvent', category)
      }
    },

    isCategoryDisable (category) {
      if (this.disableCategories.some((cate) => cate.id === category.id)) {
        return true
      }
      return false
    },

    closeModal () {
      this.$emit('closeModalEvent')
    }
  }
}
</script>

<style lang="scss" scoped>
.select-address-category-modal {
  margin: 0;
  .modal-body {
    .selectable-categories {
      display: flex;
      align-items: center;
      height: 50px;
      border-bottom: 1px solid #ddd;
      .current-category-marker {
        width: 32px;
        padding: 5px 10px;
      }
      .category-name {
        font-size: 21px;
        &.disable {
          color: #aaa;
        }
      }
    }
  }
}
</style>